import React from "react";
import * as Cookies from "js-cookie";
import { Redirect, Route, Switch } from "react-router-dom";

import { UserProfile } from "./UserProfile/UserProfile";
import { UserAccounts } from "./UserAccounts/UserAccounts";
import { UserLayout } from "../Layout/Layout";
import { UserManageUser } from "./UserManageUser/UserManageUser";
import { SelectedAccountProvider } from "../../Context/SelectedAccountContext/SelectedAccountContext";
import { AccountSearchProvider } from "../../Context/AccountSearchContext/AccountSearchContext";
import { AdminUsersNew } from "../Admin/AdminUsersNew/AdminUsersNew";
import { useQuery } from "@apollo/client";
import loggedIn from "../../GraphQL/Query/loggedIn";

export const User = () => {
  const userRole = Cookies.get("access_level");
  const { data, loading } = useQuery(loggedIn, {
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <div></div>;
  }

  if (!data?.loggedIn && !loading) {
    return <Redirect to="/login" />;
  }

  return (
    <div className="Admin">
      <SelectedAccountProvider>
        <AccountSearchProvider>
          <UserLayout role={userRole}>
            <Switch>
              <Route path="/sso/profile" exact component={UserProfile} />
              <Route path="/sso/accounts" exact component={UserAccounts} />
              <Route
                path="/sso/accounts/:id/invite-user"
                exact
                component={AdminUsersNew}
              />
              <Route
                path="/sso/accounts/:id/manage"
                exact
                component={UserManageUser}
              />
              <Route render={() => <Redirect to="/sso/profile" />} />
            </Switch>
          </UserLayout>
        </AccountSearchProvider>
      </SelectedAccountProvider>
    </div>
  );
};
